import React, { useEffect, useMemo, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import clsx from 'clsx'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'

import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text'

import { useWindowDimensions } from 'utils/hooks/useWindowDimensions'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const INITIAL_SCALE = 1.0
const PADDING_SIZE = 0

const PDFViewerLoadingState = () => (
  <div
    className="flex items-center justify-center w-screen max-w-xl max-auto bg-surface-subued"
    style={{ height: 'calc(100vh - 54px)' }}
  >
    <Text variant="body">
      <Spinner />
    </Text>
  </div>
)

const PDFViewerErrorState = () => (
  <div
    className="flex items-center justify-center w-screen max-w-xl bg-surface-subued"
    style={{ height: 'calc(100vh - 54px)' }}
  >
    <Text variant="body">Kesalahan saat memuat dokumen...</Text>
  </div>
)

export const PDFViewerEmptyState = () => (
  <div
    className="flex items-center justify-center w-screen max-w-xl bg-surface-subued"
    style={{ height: 'calc(100vh - 54px)' }}
  >
    <Text variant="body">Tidak ada dokumen yang di muat.</Text>
  </div>
)

export const PDFViewer = ({ url, className = '' }) => {
  const [wrapperWidth, setWrapperWidth] = useState<number>(0)
  const { width, getElementDimensionById } = useWindowDimensions()

  const [numPages, setNumPages] = useState<number | null>(null)
  const file = useMemo(() => ({ url }), [url])

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
  }

  useEffect(() => {
    const { width: elementWidth } = getElementDimensionById('viewerWrapper')
    setWrapperWidth(elementWidth)
  }, [getElementDimensionById])

  return (
    <div
      id="viewerContainer"
      className={clsx('pdf-viewer-container', className)}
    >
      <div id="viewerWrapper" className="pdf-viewer-wrapper">
        <TransformWrapper
          initialScale={INITIAL_SCALE}
          centerOnInit={true}
          minScale={1}
          maxScale={5}
          panning={{ disabled: true }}
          wheel={{ disabled: true }}
          doubleClick={{ disabled: true }}
        >
          <TransformComponent>
            <div>
              <Document
                file={file}
                error={PDFViewerErrorState}
                loading={PDFViewerLoadingState}
                externalLinkTarget="_blank"
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {[...Array(numPages)].map((_, index) => (
                  <Page
                    key={`pdf-viewer-page-${index}`}
                    pageNumber={index + 1}
                    className="pdf-viewer-page"
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                    scale={INITIAL_SCALE}
                    width={(wrapperWidth || width) - PADDING_SIZE}
                    loading=""
                  />
                ))}
              </Document>
            </div>
          </TransformComponent>
        </TransformWrapper>
      </div>
    </div>
  )
}
